import { map, get } from 'lodash-es';

const transformLoadPermissions = (permissions: any) =>
  map(get(permissions, 'userPermissions'), permission => ({
    isActive: permission.isActive,
    name: permission.technicalName,
  }));

export default transformLoadPermissions;
